<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebar"><a id="file_008">
<p class="image"><img alt="Image" src="images/f0007-01.jpg"/></p>
<p class="caption">This scruffy, scrappy “Hellcat” cartoon character appeared in some of the first F6F pilot’s handbooks. <em>P. J. Muller</em></p>
</a></div><a id="file_008">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_008.vue?2c282f33